import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import WhyUsPage from './pages/WhyUsPage'
import AboutPage from './pages/AboutPage'
import NewsPage from './pages/NewsPage'
import ServiceHubPage from './pages/ServiceHubPage'
import DataSecurityPage from './pages/DataSecurityPage'
import ContactPage from './pages/ContactPage'
import BioinformaticsPage from './pages/BioinformaticsPage'
import TranscriptomicsPage from './pages/TranscriptomicsPage'
import EpigenomicsPage from './pages/EpigenomicsPage'
import MassSpecPage from './pages/MassSpecPage'
import MicrobiomePage from './pages/MicrobiomePage'
import GenomicsPage from './pages/GenomicsPage'
import SingleCellPage from './pages/SingleCellPage'
import SpatialOmicsPage from './pages/SpatialOmicsPage'
import MultiOmicsPage from './pages/MultiOmicsPage'
import PipelineDevPage from './pages/PipelineDevPage'
import AIMlOverviewPage from './pages/AIMlOverviewPage'
import DrugDiscoveryPage from './pages/DrugDiscoveryPage'
import TargetIdPage from './pages/TargetIdPage'
import HitDiscoveryPage from './pages/HitDiscoveryPage'
import LeadOptimizationPage from './pages/LeadOptimizationPage'
import PreclinicalBiomarkerPage from './pages/PreclinicalBiomarkerPage'
import TranslationalPkPdPage from './pages/TranslationalPkPdPage'
import ClinicalResearchPage from './pages/ClinicalResearchPage'
import PatientStratificationPage from './pages/PatientStratificationPage'
import SurvivalRiskPage from './pages/SurvivalRiskPage'
import BiomarkerDiscoveryPage from './pages/BiomarkerDiscoveryPage'
import CohortReAnalysisPage from './pages/CohortReAnalysisPage'
import ConsultancyOverviewPage from './pages/ConsultancyOverviewPage'
import NutritionCosmeticsPage from './pages/NutritionCosmeticsPage'
import AgricultureFoodPage from './pages/AgricultureFoodPage'
import ScientificWritingPage from './pages/ScientificWritingPage'
import ServiceProcessPage from './pages/ServiceProcessPage'
import TechnicalResourcesPage from './pages/TechnicalResourcesPage'
import AppliedAIMLPage from './pages/AppliedAIMLPage'
import PublicDataMiningPage from './pages/PublicDataMiningPage'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="why-us" element={<WhyUsPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="news" element={<NewsPage />} />
          <Route path="service" element={<ServiceHubPage />} />
          <Route path="service/data-security" element={<DataSecurityPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="service-process" element={<ServiceProcessPage />} />
          <Route path="technical-resources" element={<TechnicalResourcesPage />} />

          {/* Bioinformatics */}
          <Route path="service/bioinformatics" element={<BioinformaticsPage />} />
          <Route path="service/bioinformatics/transcriptomics" element={<TranscriptomicsPage />} />
          <Route path="service/bioinformatics/epigenomics" element={<EpigenomicsPage />} />
          <Route path="service/bioinformatics/mass-spectrometry" element={<MassSpecPage />} />
          <Route path="service/bioinformatics/microbiome" element={<MicrobiomePage />} />
          <Route path="service/bioinformatics/genomics" element={<GenomicsPage />} />
          <Route path="service/bioinformatics/single-cell" element={<SingleCellPage />} />
          <Route path="service/bioinformatics/spatial-omics" element={<SpatialOmicsPage />} />
          <Route path="service/bioinformatics/multi-omics" element={<MultiOmicsPage />} />
          <Route path="service/bioinformatics/pipeline-development" element={<PipelineDevPage />} />
          <Route path="service/bioinformatics/public-data-mining" element={<PublicDataMiningPage />} />

          {/* AI/ML */}
          <Route path="service/ai-ml" element={<AIMlOverviewPage />} />
          <Route path="service/ai-ml/drug-discovery" element={<DrugDiscoveryPage />} />
          <Route path="service/ai-ml/target-identification" element={<TargetIdPage />} />
          <Route path="service/ai-ml/hit-discovery" element={<HitDiscoveryPage />} />
          <Route path="service/ai-ml/lead-optimization" element={<LeadOptimizationPage />} />
          <Route path="service/ai-ml/preclinical-biomarker" element={<PreclinicalBiomarkerPage />} />
          <Route path="service/ai-ml/translational-pkpd" element={<TranslationalPkPdPage />} />
          <Route path="service/ai-ml/clinical-research" element={<ClinicalResearchPage />} />
          <Route path="service/ai-ml/patient-stratification" element={<PatientStratificationPage />} />
          <Route path="service/ai-ml/survival-risk" element={<SurvivalRiskPage />} />
          <Route path="service/ai-ml/biomarker-discovery" element={<BiomarkerDiscoveryPage />} />
          <Route path="service/ai-ml/cohort-reanalysis" element={<CohortReAnalysisPage />} />
          <Route path="service/ai-ml/applied" element={<AppliedAIMLPage />} />

          {/* Data-Centric R&D Consultancy */}
          <Route path="service/consultancy" element={<ConsultancyOverviewPage />} />
          <Route path="service/consultancy/nutrition-cosmetics" element={<NutritionCosmeticsPage />} />
          <Route path="service/consultancy/agriculture-food" element={<AgricultureFoodPage />} />

          {/* Scientific Writing */}
          <Route path="service/scientific-writing" element={<ScientificWritingPage />} />
        </Route>
      </Routes>
    </Router>
  )
}

export default App